import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { Collapse } from '@material-ui/core'
import _ from 'lodash'

import FiltersForm from '../forms/filtersForm/FiltersForm'
import setActiveRoomClass, { resetActiveRoomClass } from '../../actions/setActiveRoomClassActions'
import { getRoomClassOptionsByCodes } from '../../utilities/content/roomClassFilter'
import caretDown from '../../assets/icons/caret-down.svg'

import '../../styles/css/components/filters/bk-flow-room-filters.css'

class BkFlowRoomFilters extends Component {
	constructor(props) {
		super(props);
		const activeRoomClassCodes = _.get(props, 'activeRoomClassData.roomClassificationCodes');
		this.state = {
		  isFilterExpanded: !_.isEmpty(activeRoomClassCodes),
		  selectedRoomClassCodes: activeRoomClassCodes ? activeRoomClassCodes: [],
		};
	  }

	render() {
		const {
			roomGroup,
			configData,
			availabilityData,
			activeRoomClassData,
			handleRoomClassReset,
			handleRoomClassChanged
		} = this.props
		const { isFilterExpanded } = this.state

		const hotelLabels = _.get(configData, 'hotel.labels[0]', [])
		let groupAvailData = null
		const activeRoomClassCodes = _.get(activeRoomClassData, 'roomClassificationCodes');
		const activeRoomClassOptions = getRoomClassOptionsByCodes(activeRoomClassCodes)

		if (
			availabilityData &&
			availabilityData[roomGroup] &&
			availabilityData[roomGroup][0]
		) {
			groupAvailData = availabilityData[roomGroup][0]
		}

		return (
			<div className="bk-flow-room__filters">
				<div className={`bk-flow-room__filters-heading ${!isFilterExpanded ? "u-remove-margin" : ""}`}>
					<button 
						aria-expanded={isFilterExpanded}
						onClick={() => {
							this.setState({isFilterExpanded: !isFilterExpanded})}
						}
						className="btn btn-text-only"
					>
						<h4 className="sublabel">
							{ hotelLabels.advancedFilters ? hotelLabels.advancedFilters : 'Advanced Filters' }
						</h4>
						<img
							alt={isFilterExpanded ? "Hide" : "Show"}
							src={caretDown}
							style={{ transform: `rotate(${isFilterExpanded ? 180 : 0}deg)`}}
						/>
					</button>
				</div>

				<Collapse 
					in={isFilterExpanded} 
					className={isFilterExpanded ? "u-expanded" : ""}
				>
					<Fragment>
						<FiltersForm
							form="filtersForm"
							configData={ configData }
							hotelLabels={hotelLabels}
							groupAvailData={groupAvailData}
							selectedRoomClassCodes={this.state.selectedRoomClassCodes}
							setSelectedRoomClassCodes={(selectedCodes)=>{this.setState({
								selectedRoomClassCodes: selectedCodes
							})}}
							isFormBarExpanded={isFilterExpanded}
						/>
						{activeRoomClassOptions && activeRoomClassOptions.length > 0 && (
							<div className="bk-form-room__filter-results">
								<div className="bk-form-room__filter-results-group">
									{_.map(activeRoomClassOptions, roomClassOption => (
										<div  key={_.get(roomClassOption, 'value')}>
											<span>{_.get(roomClassOption, 'label')}</span>
											<button 
												aria-label={`Remove ${_.get(roomClassOption, 'label')} Filter`}
												className="btn" 
												onClick={() => {
													const updatedRoomClassCodes = _.filter(activeRoomClassCodes, (code) => code !== _.get(roomClassOption,'value'))
													this.setState({selectedRoomClassCodes: updatedRoomClassCodes})
													handleRoomClassChanged(updatedRoomClassCodes)
												}}
												tabIndex={isFilterExpanded ? 0 : -1}
											>
												<i className="material-icons">close</i>
											</button>
										</div>
									))}
								</div>
								<button 
									className="btn btn-text-only"
									onClick={() => {
										this.setState({
											selectedRoomClassCodes: []
										})
										handleRoomClassReset()
									}}
									tabIndex={isFilterExpanded ? 0 : -1}
								>
									{ hotelLabels.clearAllFilters ? hotelLabels.clearAllFilters : 'Clear all filters' }
								</button>
							</div>
						)}
					</Fragment>
				</Collapse>
				
				
			</div>
		)
	}
}

//connects root reducer to props
function mapStateToProps(state) {
	return {
		urlData: state.availabilityData.urlData,
		configData: state.configData.configuration,
		availabilityData: state.availabilityData.availability,
		activeRoomClassData: state.activeRoomClassData,
	}
}

const mapDispatchToProps = (dispatch) => ({
	handleRoomClassReset() {
	  	return dispatch(resetActiveRoomClass());
	},
	handleRoomClassChanged(roomClassCodes) {
		return dispatch(setActiveRoomClass(roomClassCodes))
	}
  });

export default connect(mapStateToProps, mapDispatchToProps)(BkFlowRoomFilters)


// WEBPACK FOOTER //
// ./src/components/filters/BkFlowRoomFilters.js